import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestFormHeader } from '@Types/index';

interface OverseasMissionState {
  overseasMission: RequestFormHeader;
}

const initialState: OverseasMissionState = {
  overseasMission: getDefaultRequestState(),
};

const overseasMissionSlice = createSlice({
  name: 'overseasMission',
  initialState,
  reducers: {
    setOverseasMission: (
      state: OverseasMissionState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.overseasMission = getDefaultRequestState();
      } else {
        state.overseasMission = payload;
      }
    },
  },
});

const { actions } = overseasMissionSlice;

export const overseasMissionActions = {
  ...actions,
};

export default overseasMissionSlice;
